import { useSettings, useThumbnails, useUploader, useExporter, useEditor } from "./hooks"
import Generator from "./generator"
export default Generator
export { useSettings, useThumbnails, useUploader, useExporter, useEditor }
